import React from 'react';

export const AppFooter: React.FC = () => {
  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white mt-32 border-t-4 border-red-700">
      <div className="max-w-7xl mx-auto px-8 sm:px-10 lg:px-12 py-24">
        <div className="text-center">
          <p className="text-gray-400 text-sm mb-3">
            © 2026 AI News Hub. All rights reserved.
          </p>
          <p className="text-gray-500 text-xs">Powered by GNews API</p>
        </div>
      </div>
    </footer>
  );
};
